import { ExpressionRule } from "../../ExpressionRule";
import { ExpressionValue } from "../../ExpressionValue";
import { ExecutionData } from "../../../Common/Data/ExecutionData/ExecutionData";
import { ITestingContext } from "../../../Common/Testing/ITestingContext";
import { NumberDataDefinition } from "../../../Common/Data/Definitions/NumberDataDefinition";
import type { AppGlueAny } from "../../../Common/AppGlueAny";

export class AverageExpression extends ExpressionRule {
    readonly __type: string = "Average";
    value1: ExpressionValue;

    constructor() {
        super();

        this.expressionValueType = new NumberDataDefinition();

        let dd = new NumberDataDefinition();
        dd.list = true;
        this.value1 = ExpressionValue.createExpressionValue(this, "averageValue", dd);
    }

    evaluate(data: ExecutionData, testContext: ITestingContext | undefined): AppGlueAny {
        let value = this.value1.evaluate(data, testContext);
        if (value.length === 0) return 0;
        return value.reduce((a: number, b: number) => a + b, 0) / value.length;
    }
}
